<template>
	<div class="percentage">
		<div class="abs" v-for="item in num" :key="item">
			<div class="sub"></div>
		</div>
		<div class="inner center"></div>
		<div class="center data column-center">
			<div v-if="!show" :style="number>60?'color:#FD4238':''">
				<span class="num" >{{Number(number).toFixed(1)}}</span>
				<span>%</span>
			</div>
			<div v-else>
				<span class="num" style="color:#999999">--%</span>
			</div>
			<p>磨损率</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Percentage",
		props:{
			number:String
		},
		data(){
			return {
				num: 70,
				green: 0,
				show:false
			}
		},
		watch:{
			number(){
				this.initDate();
			}
		},
		mounted() {
			this.initDate();
		},
		methods:{
			initDate(){
				let divs = document.querySelectorAll(".abs");
				if(this.number=='--'){
					this.show = true
					this.green = -1
				}else{
					this.show = false
					this.green = (Number(this.number)*70).toFixed(0)
				}
				
				let deg = 0
				let step = 360 / this.num
				for (let i = 0; i < this.num; i++) {
					divs[i].style.transform = `rotate(${deg}deg)`
					deg += step
					divs[i].children[0].style.backgroundColor = "#E5E9EF"
					if(i <= this.green){
						if(this.number>60){
							divs[i].children[0].style.backgroundColor = "#FD4238"
						}else{
							divs[i].children[0].style.backgroundColor = "#68D86A"
						}
					}
				}
			}
		}
	}
</script>

<style scoped lang="less">
.percentage {
	position: relative;
	border-radius: 50%;
	overflow: hidden;
	width: 100%;
	height: 100%;

	.abs {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		transform: rotate(0);
	}

	.sub {
		.w(2);
		.h(16);
		background-color: #dde3eb;
		margin: 0 auto;
	}
	.inner {
		width: 70%;
		height: 70%;
		border-radius: 50%;
		border: 8px solid #dde3eb;

	}

	.center{
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}

	.data {

		font-size: 24rem;
		font-weight: 400;
		color: #68D86A;
    	width: 100%;
		line-height: 28rem;
		.num {
			font-size: 30rem;
			margin-right: 5rem;
			font-weight: bold;
		}

		p {
			color: #333333;
			font-size: 14rem;
		}
	}
}
</style>